module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card p2222"
  }, [_c('div', {}, [_vm._v("\n    " + _vm._s(_vm.now) + "\n  ")]), _vm._v(" "), _c('div', {
    ref: "touchbox"
  }, [_c('calendar', {
    ref: "calendar",
    attrs: {
      "activeDays": ['2017-4-18', '2017-4-19'],
      "unactiveDays": ['2017-4-20']
    },
    on: {
      "on-click": _vm.handle,
      "on-month-change": _vm.monthChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-012c5c4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/demo.vue
// module id = 220
// module chunks = 19